import { GradientButton } from '@/pages/Studio/components';
import { useResize } from '@/hooks/useResize';
import { Tag } from 'gatorcomponents';
import { ThemeContext } from 'styled-components';

import * as Styles from './HGStudioHighlight.styles';

import React, { useContext } from 'react';
import IconAiPen from '@/pages/Home/media/iconAiPen';

const HGStudioHighlight = ({
  element,
  buttonIsLoading = false,
}) => {
  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;
  const theme = useContext(ThemeContext);

  return (
    <Styles.DivContents id={element.id} key={element.id} data-testid={`highlight-${element.id}`}>
      <Styles.DivImg>
        <img
          src={element.image}
          alt="produto em destaque"
        />
      </Styles.DivImg>

      <Styles.DivText>
        <Styles.WrapperTitle>
          <Styles.Title data-testid={`title-${element.id}`}>{element.title}</Styles.Title>
          <IconAiPen color="primaryBlue" />
          {element.titleTag && (
            <Styles.TagAdapter>
              <Tag
                label={element.titleTag}
                variant="gradient"
                size="sm"
                gradient={{
                  color: theme.v2.colors.feedback.activeDark,
                  background: 'linear-gradient(180deg, #7BE5A3 0%, #CDFDDD 100%)',
                }}
              />
            </Styles.TagAdapter>
          )}
        </Styles.WrapperTitle>

        <Styles.Subtitle data-testid={`subtitle-${element.id}`}>
          {element.subtitle}
        </Styles.Subtitle>

        <Styles.DescriptionList>
          {element.descriptionList.map(item => (
            <Styles.DescriptionListItem key={item.id}>
              {item.icon}
              {item.text}
            </Styles.DescriptionListItem>
          ))}
        </Styles.DescriptionList>

        <Styles.ButtonWrapper>
          <GradientButton
            testId="cta"
            label={element.cta.label}
            variant="quaternary"
            size="lg"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </Styles.ButtonWrapper>
      </Styles.DivText>
    </Styles.DivContents>
  );
};

export default HGStudioHighlight;
